import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import DownloadIcon from "@mui/icons-material/Download"
import dayjs from "dayjs"
import { formatCount } from "./UsageTable"
import { downloadCsv } from "./exportCsv"

const labels = { administrador: "Administrador", supervisor: "Supervisor", operador: "Operador", other: "Outros / sem perfil", "": "Histórico sem perfil" }
const formatDate = value => value ? dayjs(value).format("DD/MM/YYYY") : "—"

const UserAccessTable = ({ users, modules }) => {
    const moduleLabels = Object.fromEntries(modules.map(module => [module.id, module.label]))
    return (
        <Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="h6">Usuários que acessaram a empresa</Typography>
                <IconButton size="small" aria-label="Baixar CSV: acessos por usuário" title="Baixar CSV: acessos por usuário" onClick={() => downloadCsv("kwik-acessos-por-usuario.csv", [
                    { key: "name", label: "Usuário" }, { key: "type", label: "Tipo" }, { key: "module", label: "Módulo" }, { key: "accesses", label: "Acessos" }, { key: "first", label: "Primeiro acesso" }, { key: "last", label: "Último acesso" },
                ], users.flatMap(user => Object.entries(user.modules).map(([module, state]) => ({ name: user.name || (user.id ? `Usuário #${user.id}` : "Histórico sem usuário"), type: labels[user.user_type] || labels.other, module: moduleLabels[module] || module, accesses: state.accesses, first: formatDate(state.first_access), last: formatDate(state.last_access) }))))}><DownloadIcon fontSize="small" /></IconButton>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Cada linha identifica o usuário, seu tipo, os módulos acessados, a quantidade e as primeiras/últimas datas no período.
            </Typography>
            <TableContainer component={Paper} variant="outlined" sx={{ overflowX: "auto" }}>
                <Table size="small" aria-label="Acessos por usuário" sx={{ minWidth: 900 }}>
                    <TableHead sx={{ bgcolor: "#F1F5F9" }}><TableRow>
                        <TableCell>Usuário</TableCell><TableCell>Tipo</TableCell><TableCell>Módulo</TableCell>
                        <TableCell align="right">Acessos</TableCell><TableCell align="center">Primeiro acesso</TableCell><TableCell align="center">Último acesso</TableCell>
                    </TableRow></TableHead>
                    <TableBody>
                        {users.flatMap(user => Object.entries(user.modules).map(([module, state]) => (
                            <TableRow key={`${user.id}-${user.user_type}-${module}`} hover>
                                <TableCell>{user.name || (user.id ? `Usuário #${user.id}` : "Histórico sem usuário")}</TableCell>
                                <TableCell>{labels[user.user_type] || labels.other}</TableCell><TableCell>{moduleLabels[module] || module}</TableCell>
                                <TableCell align="right">{formatCount(state.accesses)}</TableCell><TableCell align="center">{formatDate(state.first_access)}</TableCell><TableCell align="center">{formatDate(state.last_access)}</TableCell>
                            </TableRow>
                        ))) }
                        {!users.length && <TableRow><TableCell colSpan={6}>Nenhum acesso identificado por usuário neste período.</TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    )
}

export default UserAccessTable
